module.exports = __webpack_public_path__ + "static/media/maturity-model.17614590.png";